// Keeps a referral code for the 30-day affiliate attribution window.
const KEY = "rgm_referral_code";
const LS_KEY = "rgm_referral_stash";
const WINDOW_MS = 30 * 24 * 60 * 60 * 1000;

export const stashReferral = (code) => {
  if (!code) return;
  try { sessionStorage.setItem(KEY, code); } catch { /* storage disabled */ }
  try { localStorage.setItem(LS_KEY, JSON.stringify({ code, ts: Date.now() })); } catch { /* storage disabled */ }
};

export const readReferral = () => {
  try {
    const s = sessionStorage.getItem(KEY);
    if (s) return s;
  } catch { /* storage disabled */ }
  try {
    const raw = JSON.parse(localStorage.getItem(LS_KEY) || "null");
    if (raw?.code && Date.now() - raw.ts <= WINDOW_MS) return raw.code;
    if (raw) localStorage.removeItem(LS_KEY);
  } catch { /* ignore */ }
  return null;
};

export const clearReferral = () => {
  try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
  try { localStorage.removeItem(LS_KEY); } catch { /* ignore */ }
};
